import { OperatoreSanitarioList } from './../types/index';
import axios from 'axios';
import { OperatoreSanitario, IdVersion, OperatoreSanitarioCreateCommand, OperatoreSanitarioUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/operatori-sanitari';

export const getByKey = async (id: number): Promise<OperatoreSanitario> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const getList = async (): Promise<OperatoreSanitarioList[]> => {
    return (await axios.get(`${baseUrl}`)).data;
};

export const create = async (command: OperatoreSanitarioCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: OperatoreSanitarioUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};

